<template>
  <div class="container ptb-100">
    <div class="row gx-xxl-5">
      <div class="col-xl-8 col-lg-7">
        <div class="blog-card mb-50" v-for="blog in blogs" :key="blog.id">
          <div class="blog-img round-10 overflow-hidden">
            <img :src="blog.image" alt="Image" class="round-10 transition" />
          </div>
          <div class="blog-info">
            <ul class="blog-metainfo list-style">
              <li class="position-relative d-inline-block">
                <router-link to="/posts-by-author">
                  {{ blog.author }}
                </router-link>
              </li>
              <li class="position-relative d-inline-block">
                <span>
                  {{ blog.date }}
                </span>
              </li>
            </ul>
            <h3 class="fs-34">
              <router-link to="/blog-details-left-sidebar">
                {{ blog.title }}
              </router-link>
            </h3>
            <p class="mb-0">
              {{ blog.desc }}
            </p>
          </div>
        </div>

        <ul class="page-nav list-style">
          <li>
            <a
              class="d-flex flex-column justify-content-center align-items-center rounded-circle"
              href="#"
              ><i class="ri-arrow-left-s-line"></i>
            </a>
          </li>
          <li>
            <a
              class="d-flex flex-column justify-content-center align-items-center rounded-circle active"
              href="#"
            >
              01
            </a>
          </li>
          <li>
            <a
              class="d-flex flex-column justify-content-center align-items-center rounded-circle"
              href="#"
            >
              02
            </a>
          </li>
          <li>
            <a
              class="d-flex flex-column justify-content-center align-items-center rounded-circle"
              href="#"
            >
              03
            </a>
          </li>
          <li>
            <a
              class="d-flex flex-column justify-content-center align-items-center rounded-circle"
              href="#"
            >
              <i class="ri-arrow-right-s-line"></i>
            </a>
          </li>
        </ul>
      </div>
      <div class="col-xl-4 col-lg-5">
        <SidebarWidget />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import SidebarWidget from "./SidebarWidget.vue";

export default defineComponent({
  name: "BlogRightSidebar",
  components: {
    SidebarWidget,
  },
  data() {
    return {
      blogs: [
        {
          id: 1,
          image: require("../../assets/img/blog/blog-1.webp"),
          author: "Admin",
          date: "22 November, 2023",
          title:
            "Global Leaders Announce Historic Climate Agreement To Curb In This Sector For Business",
          desc: "Go after leads more effectively, find out the status other sales cycle, and optimize efforts. Automate most processes with powerful tools for maximum for this is a text in this season efficiency.",
        },
        {
          id: 2,
          image: require("../../assets/img/blog/blog-2.webp"),
          author: "Admin",
          date: "21 November, 2023",
          title: "The creative content creator is positive for next seminar",
          desc: "Go after leads more effectively, find out the status other sales cycle, and optimize efforts. Automate most processes with powerful tools for maximum for this is a text in this season efficiency.",
        },
        {
          id: 3,
          image: require("../../assets/img/blog/blog-3.webp"),
          author: "Admin",
          date: "20 November, 2023",
          title: "How is this possible to learn anything in summer season 2023",
          desc: "Go after leads more effectively, find out the status other sales cycle, and optimize efforts. Automate most processes with powerful tools for maximum for this is a text in this season efficiency.",
        },
        {
          id: 4,
          image: require("../../assets/img/blog/blog-4.webp"),
          author: "Admin",
          date: "19 November, 2023",
          title: "Announce history climate in last Hundred Years",
          desc: "Go after leads more effectively, find out the status other sales cycle, and optimize efforts. Automate most processes with powerful tools for maximum for this is a text in this season efficiency.",
        },
      ],
    };
  },
});
</script>